export default __webpack_public_path__ + "static/media/Extreme Precipitation Event 90e82c9c7dd54ec2aa6f1f785e457739.e7eae1ce.md";